<template>
  <div :class="containerClass">
    <div class="d--f fd--c">
      <div :class="containerClass">
        <AppIcon v-if="icon" :type="icon" color="primary" size="28" class="mr-8px" />
        <component :is="`h${size}`" :class="textCenteredClass">{{ title }}</component>
      </div>
      <p v-if="description" class="text-muted" :class="textCenteredClass">{{ description }}</p>
    </div>

    <slot />
  </div>
</template>

<script setup>
import { AppIcon } from "@/components/ui";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  centered: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: "2",
  },
});

const containerClass = ["mb-10px", props.centered ? "" : "d--f jc--sb ai--c"];
const textCenteredClass = ["ma-0", props.centered ? "d--f jc--c" : ""];
</script>
